import { Add } from "@mui/icons-material";
import {
  Box,
  Checkbox
} from "@mui/material";
import AddDeviceDialogue from "components/modules/Device/AddDeviceDialogue";
import { prepareWindowsCommand } from "components/modules/Device/helper";
import MyTableToolbar from "components/shared/Tables/MyTable/MyTableToolbar";
import { handleDownloadNetworkCsv, handlePrintNetwork } from "components/utils/handlers";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../../../../redux/slice/auth.slice";
import {
  DELETE_NETWORK,
  GET_NETWORK_DEVICE_TOKEN
} from "../../../../../redux/types/networkDevice.types";
import MapAccordion from "./MapAccordion";
import styles from "./MapSummary.module.scss";
import { mapHeaderLabels, NETWORK_DOWNLOAD_COLS } from "./helper";
import { checkSinglePermission } from "components/shared/helper";
import { accessActions } from "../../../../../redux/slice/access.slice";
import { USER_PERMISSIONS } from "components/modules/Management/AccessManagement/helper";
import toast from "react-hot-toast";

const MapSummaryTable = ({ deviceNetworks, isSingle = false }) => {
  const [selectedRows, setSelectedRows] = useState([]);



  const [selectAll, setSelectAll] = useState(false);
  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelectedRows = deviceNetworks?.map((device) => device._id);
      setSelectedRows(newSelectedRows);
    } else {
      setSelectedRows([]);
    }
    setSelectAll(event.target.checked);
  };

  const handleRowSelect = (event, _id) => {
    event.stopPropagation();
    const selectedIndex = selectedRows.indexOf(_id);
    let newSelectedRows = [];

    if (selectedIndex === -1) {
      newSelectedRows = newSelectedRows.concat(selectedRows, _id);
    } else if (selectedIndex === 0) {
      newSelectedRows = newSelectedRows.concat(selectedRows.slice(1));
    } else if (selectedIndex === selectedRows.length - 1) {
      newSelectedRows = newSelectedRows.concat(selectedRows.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedRows = newSelectedRows.concat(
        selectedRows.slice(0, selectedIndex),
        selectedRows.slice(selectedIndex + 1)
      );
    }
    setSelectedRows(newSelectedRows);
  };

  const [curlCommand, setCurlCommand] = useState("");
  const [isDeviceOpen, setIsDeviceOpen] = useState(false);
  const [selectedDeviceToken, setSelectedDeviceToken] = useState("");
  const [copied, setCopied] = useState(false);
  const [selectedOs, setSelectedOs] = useState("windows");
  const [selectedVersion, setSelectedVersion] = useState("windows11");

  const currentUser = useSelector(authActions.selectors.getCurrentUser);
  const userPermissions = useSelector(accessActions.selectors.getUserPermissions)



  const handleInstallDevice = (token) => {
    setIsDeviceOpen(!isDeviceOpen);
    setSelectedDeviceToken(token);
    if (!isDeviceOpen) {
      setCurlCommand(prepareWindowsCommand(token));
    } else {
      setCurlCommand("");
    }
  };
  const dispatch = useDispatch();

  const handleAddDeviceNetwork = () => {
    const payload = {
      orgId: currentUser?.orgId,
    };
    dispatch({ type: GET_NETWORK_DEVICE_TOKEN, payload });
  };

  const handleDeleteDeviceNetwork = async () => {
    try {
      if (!selectedRows?.length) {
        return toast.error("You must Select the network to delete")
      }
      const payload = {
        networkIds: selectedRows
      }
      dispatch({ type: DELETE_NETWORK, payload });
      setSelectedRows([]);
      setSelectAll(false);
    } catch (error) {
      console.error("Failed to delete device networks: ", error);
    }
  };

  const handleSearch = () => {

  }
  return (
    <div className={styles.container}>
      <div className={styles.staticHead}>
        <MyTableToolbar
          placeHolder={"Search For Apps"}
          btn1Txt={isSingle || !checkSinglePermission(USER_PERMISSIONS.ADD_NETWORK, userPermissions, currentUser?.role) ? null : "Discover Devices"}
          btn1Icon={Add}
          walkThroughClassName="register_network"
          onSearch={handleSearch}
          handleBtn1Click={handleAddDeviceNetwork}
          handleDeleteClick={handleDeleteDeviceNetwork}
          onDownload={() => handleDownloadNetworkCsv({ rows: deviceNetworks, columns: NETWORK_DOWNLOAD_COLS, name: "networks" })}
          onPrint={() => handlePrintNetwork({ rows: deviceNetworks, columns: NETWORK_DOWNLOAD_COLS, name: "networks" })}
          isUninstall={checkSinglePermission(USER_PERMISSIONS.DELETE_NETWORK, userPermissions, currentUser?.role)}
        />
      </div>
      <Box className={styles.scrollBody}>
        <div className={styles.tableHeader}>
          <Checkbox
            size="small"
            checked={selectAll}
            onChange={handleSelectAll}
          />
          {mapHeaderLabels.map((item, index) => (
            <div key={index} className={styles.headerItem} style={item?.style} >
              {item?.label}
            </div>
          ))}
        </div>
        <MapAccordion
          handleInstallDevice={handleInstallDevice}
          selectedRows={selectedRows}
          handleRowSelect={handleRowSelect}
          deviceNetworks={deviceNetworks}
          isSingle={isSingle}
        />
      </Box>
      <AddDeviceDialogue
        curlCommand={curlCommand}
        setCurlCommand={setCurlCommand}
        handleDeviceDialog={handleInstallDevice}
        isDeviceOpen={isDeviceOpen}
        copied={copied}
        setCopied={setCopied}
        selectedOs={selectedOs}
        setSelectedOs={setSelectedOs}
        selectedVersion={selectedVersion}
        setSelectedVersion={setSelectedVersion}
        selectedDeviceToken={selectedDeviceToken}
      />
    </div>
  );
};

export default MapSummaryTable;
